import * as methods from '../methods';
import { Resource } from '../Resource';
import { fromRaw as meFromRaw } from './me';
const rootPath = 'actura/login';
const fromRaw = {
    get: (raw) => ({ token: raw.token, user: meFromRaw.me(raw.user) })
};
export default Resource((requesterBuilder) => {
    return {
        login: methods.create({
            requesterBuilder,
            rootPath,
            fromRaw: (acturaReturn) => fromRaw.get(acturaReturn),
            toRaw: (form) => form
        })
    };
});
